import type { PipelineRunState, StageState } from '@/types/api';

type ChipKind = 'running' | 'completed' | 'failed' | 'pending' | 'paused' | 'skipped';

const LABEL: Record<ChipKind, string> = {
  running: 'running',
  completed: 'completed',
  failed: 'failed',
  pending: 'pending',
  paused: 'paused for approval',
  skipped: 'skipped'
};

function stateToKind(state: PipelineRunState | StageState): ChipKind {
  switch (state) {
    case 'running':
      return 'running';
    case 'completed':
      return 'completed';
    case 'failed':
      return 'failed';
    case 'paused_for_approval':
      return 'paused';
    case 'skipped':
      return 'skipped';
    case 'pending':
    default:
      return 'pending';
  }
}

export function Chip({
  state,
  label
}: {
  state: PipelineRunState | StageState;
  label?: string;
}): JSX.Element {
  const kind = stateToKind(state);
  return (
    <span className={`chip ${kind}`} data-chip-kind={kind}>
      <span className="dot" />
      {label ?? LABEL[kind]}
    </span>
  );
}
